module.exports = __webpack_public_path__ + "static/media/fig_6c.0a95d85a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_6c.jpg
// module id = 679
// module chunks = 0